import type { ReactNode } from "react";
import type { ViewscreenMode, AlertLevel } from "../../types/game";

interface Props {
  mode: ViewscreenMode | null;
  alertLevel: AlertLevel;
  children: ReactNode;
}

const MODE_LABELS: Record<string, string> = {
  space: "FORWARD VIEW",
  hail: "INCOMING HAIL",
  pending_hail: "INCOMING HAIL",
  tactical: "TACTICAL VIEW",
  magnify: "MAGNIFICATION",
  surface_map: "SURFACE MAP",
  scan_readout: "SCAN READOUT",
  chart: "STAR CHART",
  recording: "RECORDING",
};

export function ViewscreenFrame({ mode, alertLevel, children }: Props) {
  const modeKey = mode?.mode ?? "space";
  const label = MODE_LABELS[modeKey] ?? "FORWARD VIEW";
  const alertClass = alertLevel !== "normal" ? ` viewscreen-frame--${alertLevel}` : "";

  return (
    <div className={`viewscreen-frame${alertClass}`}>
      {/* Corner accents */}
      <div className="viewscreen-frame__corner viewscreen-frame__corner--tl" />
      <div className="viewscreen-frame__corner viewscreen-frame__corner--tr" />
      <div className="viewscreen-frame__corner viewscreen-frame__corner--bl" />
      <div className="viewscreen-frame__corner viewscreen-frame__corner--br" />

      {/* Scanlines overlay */}
      <div className="viewscreen-frame__scanlines" />

      {/* Vignette overlay */}
      <div className="viewscreen-frame__vignette" />

      {/* Content */}
      <div className="viewscreen-frame__content">
        {children}
      </div>

      {/* Mode indicator — bottom edge of frame */}
      <div className="viewscreen-frame__mode">
        <span className="viewscreen-frame__mode-dot" />
        <span className="viewscreen-frame__mode-label">{label}</span>
      </div>
    </div>
  );
}
